var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-extra-container"},[_c('div',{class:['banner-container', _vm.variant, _vm.size]},[_vm._t("default"),_c('div',{ref:"closeButton",staticClass:"clickable-icon",on:{"click":_vm.onClose}},[_c('svg-icon',{attrs:{"name":"close"}})],1)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }